import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from 'authentication/guards/auth.guard';
import { DashboardWrapperComponent } from 'dashboard/components/dashboard-wrapper/dashboard-wrapper.component';
import { VisualsDashboardComponent } from 'dashboard/components/visuals-dashboard/visuals-dashboard.component';
import { FeatureFlagEnum } from 'shared/interfaces/environment.interface';
import { getFeatureFlag } from 'shared/util/feature-flag.utils';
import { DashboardComponent } from './components';

const singleDashboardRoutes: Routes = [
    {
        path: '',
        component: DashboardComponent,
        canActivate: [AuthGuard],
        data: {
            pageTitle: 'breadcrumbs.dashboard',
            header: {
                breadcrumbs: [{ label: 'breadcrumbs.dashboard', icon: 'home' }],
            },
        },
    },
    {
        path: '**',
        redirectTo: '',
    },
];

const multiDashboardRoutes: Routes = [
    {
        path: '',
        component: DashboardWrapperComponent,
        canActivate: [AuthGuard],
        data: {
            pageTitle: 'breadcrumbs.dashboard',
            header: {
                breadcrumbs: [{ label: 'breadcrumbs.dashboard', icon: 'home' }],
            },
        },
        children: [
            {
                path: 'content',
                component: DashboardComponent,
                data: {
                    pageTitle: 'breadcrumbs.contentDashboard',
                },
            },
            {
                path: 'visuals',
                component: VisualsDashboardComponent,
                data: {
                    pageTitle: 'breadcrumbs.visualsDashboard',
                },
            },
            {
                path: '**',
                redirectTo: 'content',
            },
        ],
    },
];

function getRoutesByFeatureFlag(): Routes {
    return getFeatureFlag(FeatureFlagEnum.VISUALS_DASHBOARD) ? multiDashboardRoutes : singleDashboardRoutes;
}

@NgModule({
    imports: [RouterModule.forChild(getRoutesByFeatureFlag())],
    exports: [RouterModule],
})
export class DashboardRoutingModule {}
